import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface Tenant {
  id: number;
  name: string;
  taxId?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  iban?: string | null;
  guarantor?: string | null;
  created: string;
  lastModified: string;
}

export interface TenantPayload {
  name: string;
  taxId?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  iban?: string | null;
  guarantor?: string | null;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export function getTenants(): Promise<Tenant[]> {
  return request<Tenant[]>("/api/tenants");
}

export function getTenantById(tenantId: number): Promise<Tenant> {
  return request<Tenant>(`/api/tenants/${tenantId}`);
}

export function createTenant(payload: TenantPayload): Promise<Tenant> {
  return request<Tenant>("/api/tenants", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateTenant(
  tenantId: number,
  payload: TenantPayload,
): Promise<Tenant> {
  return request<Tenant>(`/api/tenants/${tenantId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
